import { Button } from '@/components/Buttons';
import * as stylex from '@stylexjs/stylex';
import '../../styles/tokens.stylex';
import { borderRadius, color, fontFamilies, spacing } from '../../styles/tokens.stylex';
import { typography } from '../../styles/typography';
import { OnFormSubmitted } from './FormSubmitted';
export interface FormDialogProps {
  dialogRef: (node: HTMLDialogElement) => void;
  formId: string;
  closeDialog: (id: string) => void;
}
export function FormDialog({
  dialogRef,
  closeDialog,
  formId
}: FormDialogProps) {
  const close = () => closeDialog(formId);
  return <dialog ref={dialogRef} className="xfeu2k6 xnlluxf xng3xce xjbqb8w x11x033 xh8yej3" onClick={close} data-lock-scroll>
      <section onClick={e => e.stopPropagation()} className="xixxii4 xid9tje x10a8y8t xh8yej3 x1dtb55y x78zum5 xdt5ytf x1xlpcrp xhvgg9w xvueqy4 x1algulf">
        <header className="x7wzq59 xid9tje x13vifvy x78zum5 x6s0dn4 x1o4oh2x x1q0q8m5 xbq8vbv xso031l xycymia x1c4vz4f x7d3uan x8671rx">
          <div className="x2b8uid">
            <h1 {...stylex.props(typography.display2)}>Get a quote</h1>
          </div>

          <div className="x1iyjqo2 x78zum5 x15zctf7">
            <Button onClick={close} iconOnly="x" variant="ghost" theme="neutral">
              Close Dialog
            </Button>
          </div>
        </header>
        <main className="x169mek3 x2b8uid x1o4oh2x x78zum5 xdt5ytf x1mhrlx8 x98rzlu">
          <div data-hubspot-embed-form-id={`${formId}`} className="x9reedh x98rzlu"></div>
          <OnFormSubmitted formId={formId} />
        </main>
      </section>
    </dialog>;
}